import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';


function addProducts() {
  return (
    <div>
      <h3>Inquiry Management</h3>
      <div className='breadcrum mb-5'>
        <p><Link to="/contact"><span >Inquiry Management</span></Link> <FontAwesomeIcon
          icon={faAngleRight}
          className="mx-2"
        /><span className='active-link'>View</span></p>
      </div>

      <div className="content-wrapper">
        <div className='row'>
          <div className='col-md-6 col-sm-12 col-lg-6'>
            <div className="mb-3 text-start">
              <label htmlFor="title" className="form-label">
                Name
              </label>
              <input
                type="email"
                className="form-control"
                id="title"
                placeholder="Title"
                required
              />
            </div>
          </div>

          <div className='col-md-6 col-sm-12 col-lg-6'>
            <div className="mb-3 text-start">
              <label htmlFor="buttontext" className="form-label">
                Email
              </label>
              <input
                type="text"
                className="form-control"
                id="buttontext"
                placeholder="Button Text"
                required
              />
            </div>
          </div>


          <div className='col-md-12 col-sm-12 col-lg-12'>
            <div className="mb-3 text-start">
              <label htmlFor="buttontext" className="form-label">
                Subject
              </label>
              <input
                type="text"
                className="form-control"
                id="buttontext"
                placeholder="Subject"
                required
              />
            </div>
          </div>

          <div className='col-md-12 col-sm-12 col-lg-12'>
            <div className="mb-3 text-start">
              <label htmlFor="buttontext" className="form-label">
                Message
              </label><br />
              <textarea className="form-control" rows={3}></textarea>
            </div>
          </div>


        </div>
      </div>
    </div>


  )
}

export default addProducts